/* ═══════════════════════════════════════════════════════════════
   LUX HERESY — theme.js  (Phase 8: Subtle Persuasion Engine)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── RAF scroll throttle ───────────────────────────────────── */
  let sTick = false;
  function onScroll(cb) {
    window.addEventListener('scroll', () => {
      if (!sTick) { requestAnimationFrame(() => { cb(); sTick = false; }); sTick = true; }
    }, { passive: true });
  }

  /* ── Custom cursor ─────────────────────────────────────────── */
  const dot = document.getElementById('cursorDot');
  const ring = document.getElementById('cursorRing');
  if (dot && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    });
    (function lerpCursor() {
      rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(lerpCursor);
    })();
    const hoverSel = 'a,button,.prod-card,.tile,.tool-card,.lv-a-tile,.cred-card,.pain-card';
    document.querySelectorAll(hoverSel).forEach(el => {
      el.addEventListener('mouseenter', () => { ring.style.width = '50px'; ring.style.height = '50px'; ring.style.borderColor = 'rgba(212,136,58,.55)'; });
      el.addEventListener('mouseleave', () => { ring.style.width = '34px'; ring.style.height = '34px'; ring.style.borderColor = 'rgba(212,136,58,.35)'; });
    });
  }

  /* ── Nav scroll lift ───────────────────────────────────────── */
  const nav = document.querySelector('.lh-nav');
  if (nav) onScroll(() => nav.classList.toggle('scrolled', window.scrollY > 30));

  /* ── Announcement close ────────────────────────────────────── */
  const annClose = document.getElementById('annClose');
  const annBar = document.getElementById('annBar');
  if (annClose && annBar) {
    annClose.addEventListener('click', () => {
      annBar.style.maxHeight = annBar.scrollHeight + 'px';
      annBar.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        annBar.style.transition = 'max-height .35s ease,opacity .3s ease,padding .35s';
        annBar.style.maxHeight = '0'; annBar.style.opacity = '0'; annBar.style.padding = '0';
      });
      setTimeout(() => annBar.remove(), 380);
    });
  }

  /* ── Mobile nav ────────────────────────────────────────────── */
  /*
   * The drawer panel anchors to the bottom of the live header (which
   * may include the announcement bar). We expose the live header
   * height as the CSS variable --hdr-h so the panel's `top` always
   * matches reality, even after the announcement bar is dismissed,
   * the viewport is rotated, or a sticky header collapses on scroll.
   *
   * Everything is event-driven, transition-friendly, and tap-safe on
   * iOS Safari (passive listeners, body-class scroll lock instead of
   * inline overflow style, and an explicit backdrop so taps outside
   * the panel close it cleanly).
   */
  const hbg       = document.getElementById('navHbg');
  const mob       = document.getElementById('navMob');
  const backdrop  = document.getElementById('navMobBackdrop');
  const headerEl  = document.getElementById('lhNav');
  const annBarEl  = document.getElementById('annBar');

  function setHdrHVar() {
    if (!headerEl) return;
    // Header height + announcement bar (if still in DOM and visible)
    const annH = annBarEl && annBarEl.offsetParent !== null ? annBarEl.offsetHeight : 0;
    const navH = headerEl.offsetHeight;
    document.documentElement.style.setProperty('--hdr-h', (annH + navH) + 'px');
  }
  setHdrHVar();
  window.addEventListener('resize',           setHdrHVar, { passive: true });
  window.addEventListener('orientationchange',setHdrHVar, { passive: true });

  function setMobOpen(open) {
    if (!mob || !hbg) return;
    setHdrHVar();
    mob.classList.toggle('open', open);
    if (backdrop) backdrop.classList.toggle('open', open);
    hbg.setAttribute('aria-expanded', open);
    document.body.classList.toggle('nav-locked', open);
    const spans = hbg.querySelectorAll('span');
    if (open) {
      spans[0].style.transform = 'translateY(6.5px) rotate(45deg)';
      spans[1].style.opacity   = '0';
      spans[2].style.transform = 'translateY(-6.5px) rotate(-45deg)';
    } else {
      spans.forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
    }
  }

  if (hbg && mob) {
    hbg.addEventListener('click', () => setMobOpen(!mob.classList.contains('open')));
    // Tap a link → close before navigation completes (smooth visual)
    mob.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => setMobOpen(false));
    });
    // Tap backdrop → close
    if (backdrop) backdrop.addEventListener('click', () => setMobOpen(false));
    // Escape → close
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && mob.classList.contains('open')) setMobOpen(false);
    });
  }

  /* ── Smooth anchor scroll ──────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' }); }
    });
  });

  /* ── Stars canvas ──────────────────────────────────────────── */
  const canvas = document.getElementById('heroStars');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let stars = [];
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    const initStars = () => {
      stars = [];
      const n = Math.floor((canvas.width * canvas.height) / 7000);
      for (let i = 0; i < n; i++) stars.push({ x: Math.random() * canvas.width, y: Math.random() * canvas.height, r: Math.random() * 1.1 + .2, a: Math.random(), da: .002 + Math.random() * .008, ph: Math.random() * Math.PI * 2 });
    };
    const drawStars = t => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(s => { const a = s.a * (.5 + .5 * Math.sin(t * s.da + s.ph)); ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2); ctx.fillStyle = `rgba(240,230,211,${a})`; ctx.fill(); });
      requestAnimationFrame(drawStars);
    };
    resize(); initStars(); drawStars(0);
    window.addEventListener('resize', () => { resize(); initStars(); }, { passive: true });
  }

  /* ── Hero orb parallax ─────────────────────────────────────── */
  const orbs = document.querySelectorAll('.hero-orb');
  if (orbs.length) {
    const speeds = [.04, .07, .03];
    onScroll(() => { const sy = window.scrollY; orbs.forEach((o, i) => { o.style.transform = `translate(0,${sy * speeds[i]}px)`; }); });
  }

  /* ── Visibility (MODIFIED: No scroll animation, instant + hover) ── */
  /* Elements with [data-r] are now visible immediately with hover enhancement */
  document.querySelectorAll('[data-r]').forEach(el => {
    el.classList.add('on'); // Make visible immediately
    // Add subtle hover lift effect instead of scroll reveal
    el.addEventListener('mouseenter', () => {
      el.style.transform = 'translateY(-2px)';
      el.style.transition = 'transform 0.3s ease';
    });
    el.addEventListener('mouseleave', () => {
      el.style.transform = '';
    });
  });

  /* ── Counter animation (MODIFIED: Triggers on load, not scroll) ── */
  function animateCounters() {
    document.querySelectorAll('[data-count]').forEach(el => {
      const target = +el.dataset.count;
      const suffix = el.textContent.replace(/[\d,]/g, '').trim();
      let current = 0;
      const inc = target / (1200 / 16); // Faster animation
      const t = setInterval(() => {
        current = Math.min(current + inc, target);
        el.textContent = (current >= 1000 ? Math.round(current).toLocaleString() : Math.round(current)) + (suffix || '');
        if (current >= target) { clearInterval(t); el.textContent = target + (target >= 1000 ? '+' : '') + (suffix || ''); }
      }, 16);
    });
  }
  // Run counters after short delay for page load
  setTimeout(animateCounters, 300);

  /* ── Discovery tiles (PHASE 5 — interactive expand) ───────── */
  document.querySelectorAll('.tile').forEach(tile => {
    // Mouse glow
    tile.addEventListener('mousemove', e => {
      const r = tile.getBoundingClientRect();
      tile.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
      tile.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
    });
    // Click expand
    tile.addEventListener('click', () => {
      const isActive = tile.classList.contains('active');
      document.querySelectorAll('.tile.active').forEach(t => t.classList.remove('active'));
      if (!isActive) tile.classList.add('active');
    });
  });

  /* ── Science section tabs ──────────────────────────────────── */
  document.querySelectorAll('.sci-tab').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      document.querySelectorAll('.sci-tab').forEach(t => t.classList.toggle('active', t.dataset.tab === target));
      document.querySelectorAll('.sci-panel').forEach(p => p.classList.toggle('active', p.dataset.panel === target));
    });
  });

  /* ── FAQ accordion ─────────────────────────────────────────── */
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const ans = btn.nextElementSibling, isOpen = btn.classList.contains('open');
      document.querySelectorAll('.faq-q.open').forEach(q => { q.classList.remove('open'); q.setAttribute('aria-expanded','false'); q.nextElementSibling.classList.remove('open'); });
      if (!isOpen) { btn.classList.add('open'); btn.setAttribute('aria-expanded','true'); ans.classList.add('open'); }
    });
  });

  /* ── Bar chart animation (MODIFIED: Triggers on load) ────────── */
  function animateCharts() {
    document.querySelectorAll('.results-chart').forEach(el => {
      el.querySelectorAll('[data-w]').forEach((bar, i) => {
        const w = bar.dataset.w; 
        bar.style.width = '0%';
        setTimeout(() => { 
          bar.style.transition = 'width .7s cubic-bezier(.16,1,.3,1)'; 
          bar.style.width = w + '%'; 
        }, 400 + i * 100);
      });
    });
  }
  setTimeout(animateCharts, 500);

  /* ── Science insights (MODIFIED: Hover-triggered, not scroll) ── */
  const INSIGHTS = [
    "480nm light is the peak melatonin suppressor in your retina.",
    "Even 15 min of blue exposure after 9pm is measurable hormonally.",
    "Amber lenses block 80–99% of the critical melanopsin-activating range.",
    "Your circadian rhythm can be recalibrated in as little as 3 days.",
    "The green range (520–560nm) is a secondary suppressor most brands ignore.",
  ];
  let insightIdx = 0;
  
  // Show insight on hover over science-related elements (non-intrusive)
  document.querySelectorAll('.sci-step, .tile, .tool-card').forEach(el => {
    let timeout;
    el.addEventListener('mouseenter', () => {
      timeout = setTimeout(() => {
        const existing = document.querySelector('.micro-insight');
        if (existing) existing.remove();
        
        const insight = document.createElement('div');
        insight.className = 'micro-insight';
        insight.textContent = '💡 ' + INSIGHTS[insightIdx++ % INSIGHTS.length];
        insight.style.cssText = 'position:fixed;bottom:20px;right:20px;max-width:280px;background:var(--surface-2);border:1px solid var(--rim-amber);border-radius:12px;padding:12px 16px;font-family:var(--ff-m);font-size:.7rem;letter-spacing:.05em;color:var(--txt-2);z-index:1000;box-shadow:0 8px 32px rgba(0,0,0,.5);opacity:0;transform:translateY(10px);transition:opacity .5s ease,transform .5s ease;line-height:1.6;cursor:pointer;';
        insight.addEventListener('click', () => insight.remove());
        document.body.appendChild(insight);
        requestAnimationFrame(() => { insight.style.opacity='1'; insight.style.transform='translateY(0)'; });
        setTimeout(() => {
          if (insight.parentNode) {
            insight.style.opacity='0'; insight.style.transform='translateY(10px)';
            setTimeout(() => insight.remove(), 500);
          }
        }, 5000);
      }, 2000); // Only show after 2s hover (prevents spam)
    });
    el.addEventListener('mouseleave', () => clearTimeout(timeout));
  });

  /* ── Product section interaction ────────────────────────────── */
  document.querySelectorAll('.prod-card').forEach(c => {
    c.addEventListener('mousemove', e => {
      const r = c.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5;
      const y = (e.clientY - r.top) / r.height - .5;
      c.style.transform = `translateY(-5px) rotateY(${x * 4}deg) rotateX(${-y * 4}deg)`;
    });
    c.addEventListener('mouseleave', () => { c.style.transform = ''; });
  });

  /* ══════════════════════════════════════════════════════════════
     MAGNETIC BUTTON EFFECT — Premium "pull" interaction
     Buttons subtly follow cursor when hovering near them
     ══════════════════════════════════════════════════════════════ */
  document.querySelectorAll('.btn-primary, .btn-sage, .hero-cta a').forEach(btn => {
    const strength = 0.3; // Pull strength (0-1)
    const maxDistance = 80; // Max pull distance in pixels
    
    btn.style.transition = 'transform 0.2s ease-out';
    
    btn.addEventListener('mousemove', e => {
      const rect = btn.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      const deltaX = e.clientX - centerX;
      const deltaY = e.clientY - centerY;
      
      // Calculate pull (stronger when closer to edge)
      const pullX = deltaX * strength;
      const pullY = deltaY * strength;
      
      btn.style.transform = `translate(${pullX}px, ${pullY}px)`;
    });
    
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = 'translate(0, 0)';
    });
  });

  /* ══════════════════════════════════════════════════════════════
     CURSOR GLOW ENHANCEMENT — ambient glow follows cursor everywhere
     ══════════════════════════════════════════════════════════════ */
  const cursorGlow = document.createElement('div');
  cursorGlow.className = 'cursor-glow';
  cursorGlow.style.cssText = `
    position: fixed;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(212,136,58,0.08) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
    z-index: 9998;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s ease;
  `;
  document.body.appendChild(cursorGlow);

  // Show the glow on first movement, then keep it visible site-wide.
  // Previously the glow only showed when hovering .tool-card/.tile/etc —
  // which made the cursor animation "stop" anywhere else on the page.
  let glowShown = false;
  document.addEventListener('mousemove', e => {
    cursorGlow.style.left = e.clientX + 'px';
    cursorGlow.style.top = e.clientY + 'px';
    if (!glowShown) {
      cursorGlow.style.opacity = '1';
      glowShown = true;
    }
  });

  // Intensify on hover over interactive elements (keeps the old "attraction" feel)
  document.querySelectorAll('a, button, .tool-card, .tile, .tat-tile, .prod-card, .sci-panel').forEach(el => {
    el.addEventListener('mouseenter', () => {
      cursorGlow.style.background = 'radial-gradient(circle, rgba(212,136,58,0.16) 0%, transparent 70%)';
    });
    el.addEventListener('mouseleave', () => {
      cursorGlow.style.background = 'radial-gradient(circle, rgba(212,136,58,0.08) 0%, transparent 70%)';
    });
  });

  /* ── Variant A tile reveal ─────────────────────────────────── */
  document.querySelectorAll('.lv-a-tile').forEach(t => {
    t.addEventListener('click', () => {
      const body = t.querySelector('.lv-a-tile-body');
      if (body) { body.style.maxHeight = body.style.maxHeight ? '' : body.scrollHeight + 'px'; t.classList.toggle('expanded'); }
    });
  });

  /* ════════════════════════════════════════════════════════════
     CART DRAWER  (v3.7.2)
     ────────────────────────────────────────────────────────────
     Self-contained module exposed at window.LH_Cart. Talks to
     Shopify's native cart endpoints — /cart.js (read),
     /cart/add.js (add), /cart/change.js (qty + remove).
     Re-renders the drawer body off the JSON response on every
     mutation; emits a `cart:updated` document event so any other
     UI piece (e.g. the header badge) can react without coupling.
     ════════════════════════════════════════════════════════════ */
  (function initCart() {
    const drawer    = document.getElementById('cartDrawer');
    const backdrop  = document.getElementById('cartBackdrop');
    const closeBtn  = document.getElementById('cartClose');
    const navCart   = document.getElementById('navCart');
    const navCount  = document.getElementById('navCartCount');
    const cartBody  = document.getElementById('cartBody');
    const cartFoot  = document.getElementById('cartFoot');
    const cartHeadCount = document.getElementById('cartHeadCount');
    if (!drawer || !backdrop) return; // safety: not rendered

    /* ── format money ──
       Pull the shop's money_format from {{ shop.money_format }} would
       require liquid; we use a simple "$X.YY" fallback that matches
       Shopify's default and works for USD shops. The drawer also
       trusts the `money` filter for the SSR'd subtotal so on first
       paint formatting is always correct. */
    function fmt(cents) {
      return 'A$' + (Math.max(0, cents) / 100).toFixed(2).replace(/\.00$/, ''); /* v6.11.2: A$ whole dollars, matches Liquid */
    }

    function open()  {
      drawer.classList.add('open');
      backdrop.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-locked');
      // Pull the freshest cart state on every open so the drawer never
      // shows a stale line-item list (e.g. after a change in another tab).
      refresh();
      // Focus the close button for keyboard users
      closeBtn && closeBtn.focus({ preventScroll: true });
    }
    function close() {
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-locked');
    }

    /* ── render line items + footer from /cart.js JSON ── */
    function render(cart) {
      // Header count
      if (cartHeadCount) cartHeadCount.textContent = cart.item_count;
      // Nav badge
      if (navCount) {
        navCount.textContent = cart.item_count;
        if (cart.item_count > 0) navCount.removeAttribute('hidden');
        else navCount.setAttribute('hidden', '');
      }
      // Empty?
      if (cart.item_count === 0) {
        cartBody.innerHTML = `
          <div class="cart-empty">
            <div class="cart-empty-mark" aria-hidden="true">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="21" r="1"/>
                <circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
            </div>
            <p class="cart-empty-msg">Your bag is empty.</p>
            <a href="/pages/shop-the-system" class="cart-empty-cta">
              Browse the system
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </a>
          </div>`;
        if (cartFoot) cartFoot.setAttribute('hidden', '');
        return;
      }
      // Items
      const itemsHtml = cart.items.map((item, i) => {
        const variant = item.variant_title && !/Default/i.test(item.variant_title)
          ? `<div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>` : '';
        const lhEngravable = ['daybreak', 'dusk', 'terminal'].indexOf(item.handle) > -1; /* v6.11.2: mirrors snippets/cart-drawer-engraving.liquid 1:1 */
      const engraving = (item.properties && item.properties.Engraving)
        ? '<div class="lh-cart-engraving is-set" data-cart-engraving><span class="lh-cart-engraving__mark" aria-hidden="true">✦</span><span class="lh-cart-engraving__label">Engraved</span><span class="lh-cart-engraving__value">' + escapeHtml(item.properties.Engraving) + '</span><button type="button" class="lh-cart-engraving__edit" data-engrave-edit data-key="' + escapeHtml(item.key) + '">Edit</button></div>'
        : (lhEngravable ? '<button type="button" class="lh-cart-engraving is-empty" data-cart-engraving data-engrave-edit data-key="' + escapeHtml(item.key) + '"><span class="lh-cart-engraving__mark" aria-hidden="true">✦</span><span class="lh-cart-engraving__prompt">Add free engraving</span><span class="lh-cart-engraving__note">On the house</span></button>' : '');
        const imgSrc = item.image
          ? item.image.replace(/\.(\w+)(\?|$)/, '_160x.$1$2')
          : '';
        const imgHtml = imgSrc
          ? `<img src="${imgSrc}" alt="${escapeHtml(item.product_title)}" width="80" height="80" loading="lazy">`
          : `<div class="cart-item-img-fallback"></div>`;
        return `
          <li class="cart-item" data-key="${escapeHtml(item.key)}" data-line="${i + 1}">
            <a class="cart-item-img" href="${item.url}" tabindex="-1" aria-hidden="true">${imgHtml}</a>
            <div class="cart-item-info">
              <a class="cart-item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
              ${variant}
              ${engraving}
              <div class="cart-item-price">${fmt(item.final_line_price)}</div>
              <div class="cart-item-controls">
                <div class="cart-qty" role="group" aria-label="Quantity">
                  <button type="button" class="cart-qty-btn" data-act="dec" aria-label="Decrease quantity">−</button>
                  <input type="text" inputmode="numeric" pattern="[0-9]*" class="cart-qty-val"
                         value="${item.quantity}" aria-label="Quantity">
                  <button type="button" class="cart-qty-btn" data-act="inc" aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="cart-item-remove" data-act="rem" aria-label="Remove">Remove</button>
              </div>
            </div>
          </li>`;
      }).join('');
      cartBody.innerHTML = `<ul class="cart-items" id="cartItems" aria-label="Cart line items">${itemsHtml}</ul>`;

      // Footer subtotal
      if (cartFoot) {
        cartFoot.removeAttribute('hidden');
        const sub = cartFoot.querySelector('#cartSubtotal');
        if (sub) sub.textContent = fmt(cart.total_price);
      }
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    /* ── /cart.js fetchers ── */
    function refresh() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(r => r.json())
        .then(cart => {
          render(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          return cart;
        })
        .catch(err => { console.warn('Cart refresh failed:', err); });
    }
    function changeLine(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity: qty }),
      })
        .then(r => r.json())
        .then(cart => {
          render(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          return cart;
        })
        .catch(err => { console.warn('Cart change failed:', err); });
    }
    function addForm(form) {
      const btn = form.querySelector('button[type="submit"], button[name="add"]');
      const origLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      const fd = new FormData(form);
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      })
        .then(r => r.json().then(j => ({ ok: r.ok, status: r.status, body: j })))
        .then(({ ok, body }) => {
          if (!ok) {
            // Shopify returns { description, message, status } on 422 (e.g. inventory)
            const msg = (body && (body.description || body.message)) || 'Could not add to cart.';
            toast(msg, true);
            return;
          }
          return refresh().then(() => { open(); toast('Added to bag'); });
        })
        .catch(err => { console.warn('Cart add failed:', err); toast('Network error — try again.', true); })
        .finally(() => {
          if (btn) { btn.disabled = false; btn.textContent = origLabel; }
        });
    }

    /* ── tiny toast ── */
    let toastEl = null;
    function toast(msg, isError) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'cart-toast';
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      toastEl.classList.toggle('cart-toast--err', !!isError);
      requestAnimationFrame(() => toastEl.classList.add('show'));
      clearTimeout(toast._t);
      toast._t = setTimeout(() => toastEl.classList.remove('show'), 2200);
    }

    /* ── Wire UI ── */
    if (navCart)  navCart.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });

    // Delegate qty/remove inside the drawer
    drawer.addEventListener('click', e => {
      const btn = e.target.closest('[data-act]');
      if (!btn) return;
      const li = btn.closest('.cart-item');
      if (!li) return;
      const line = parseInt(li.dataset.line, 10);
      const valEl = li.querySelector('.cart-qty-val');
      const cur   = valEl ? parseInt(valEl.value, 10) || 1 : 1;
      const act = btn.dataset.act;
      if (act === 'inc') changeLine(line, cur + 1);
      else if (act === 'dec') changeLine(line, Math.max(0, cur - 1));
      else if (act === 'rem') changeLine(line, 0);
    });
    drawer.addEventListener('change', e => {
      if (!e.target.classList || !e.target.classList.contains('cart-qty-val')) return;
      const li = e.target.closest('.cart-item');
      if (!li) return;
      const line = parseInt(li.dataset.line, 10);
      const qty  = Math.max(0, parseInt(e.target.value, 10) || 0);
      changeLine(line, qty);
    });

    // Intercept any product form on the page (PDP "Add to cart")
    document.addEventListener('submit', e => {
      const form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      const action = (form.getAttribute('action') || '').toLowerCase();
      if (!action.includes('/cart/add')) return;
      e.preventDefault();
      addForm(form);
    });

    // Public API
    window.LH_Cart = { open, close, refresh, add: addForm };

    /* ── v6.11.2 ENGRAVING EDITOR ────────────────────────
       Inline Add/Edit for the free case engraving, in the drawer and on
       /cart. Rewrites the line's Engraving property via /cart/change.js
       (keeps quantity + any other properties), so editing never creates a
       duplicate line. Same rules as the PDP field: A-Z 0-9 . - &, max 6. */
    (function () {
      var MAX = 6;
      function clean(v) { return String(v || '').toUpperCase().replace(/[^A-Z0-9.&-]/g, '').slice(0, MAX); }
      function after() {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        refresh();
      }
      function lock(wrap, on) { wrap.classList.toggle('is-busy', on); wrap.querySelectorAll('button, input').forEach(function (el) { el.disabled = on; }); }
      function save(key, value, wrap) {
        lock(wrap, true);
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var line = cart.items.filter(function (it) { return it.key === key; })[0];
            if (!line) { after(); return; }
            var props = {};
            Object.keys(line.properties || {}).forEach(function (k) { if (k !== 'Engraving' && line.properties[k] !== null && line.properties[k] !== '') props[k] = line.properties[k]; });
            if (!value) {
              /* Shopify ignores properties: {} and stores "" for a blank value, so a true removal
                 = re-add the variant without the property, then drop the engraved line.
                 Add first, so nothing is lost if the second request fails. */
              var plain = { id: line.variant_id, quantity: line.quantity };
              if (Object.keys(props).length) plain.properties = props;
              return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [plain] }) })
                .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }); })
                .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); after(); });
            }
            props.Engraving = value;
            return fetch('/cart/change.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: line.quantity, properties: props })
            }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); after(); });
          })
          .catch(function (err) {
            console.warn('Engraving update failed:', err);
            lock(wrap, false);
            var msg = wrap.querySelector('.lh-cart-engrave-edit__help');
            if (msg) msg.textContent = 'Could not save. Check your connection and try again.';
          });
      }
      function openEditor(trigger) {
        var panel = trigger.closest('[data-cart-engraving]') || trigger;
        var key = trigger.getAttribute('data-key');
        var valEl = panel.querySelector('.lh-cart-engraving__value');
        var current = valEl ? valEl.textContent.trim() : '';
        var wrap = document.createElement('div');
        wrap.className = 'lh-cart-engrave-edit';
        wrap.innerHTML =
          '<label class="lh-cart-engrave-edit__lbl">Engraving, inside the lid</label>' +
          '<div class="lh-cart-engrave-edit__row"><input type="text" class="lh-cart-engrave-edit__input" maxlength="6" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="e.g. ARS" aria-label="Engraving text, up to 6 characters"><span class="lh-cart-engrave-edit__count" aria-live="polite">0 / 6</span></div>' +
          '<div class="lh-cart-engrave-edit__actions"><button type="button" class="lh-cart-engrave-edit__save" data-engrave-save>Save</button><button type="button" class="lh-cart-engrave-edit__cancel" data-engrave-cancel>Cancel</button>' +
          (current ? '<button type="button" class="lh-cart-engrave-edit__remove" data-engrave-remove>Remove</button>' : '') + '</div>' +
          '<p class="lh-cart-engrave-edit__help">A&ndash;Z, 0&ndash;9, period, hyphen, ampersand. Locked at checkout, non-returnable once engraved. Adds 3 business days to dispatch.</p>';
        panel.replaceWith(wrap);
        var input = wrap.querySelector('input');
        var count = wrap.querySelector('.lh-cart-engrave-edit__count');
        function sync() { var c = clean(input.value); if (c !== input.value) input.value = c; count.textContent = c.length + ' / 6'; }
        input.value = current; sync();
        input.addEventListener('input', sync);
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); wrap.querySelector('[data-engrave-save]').click(); }
          if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); wrap.querySelector('[data-engrave-cancel]').click(); }
        });
        wrap.querySelector('[data-engrave-cancel]').addEventListener('click', function () { wrap.replaceWith(panel); });
        wrap.querySelector('[data-engrave-save]').addEventListener('click', function () {
          var v = clean(input.value);
          if (v === current) { wrap.replaceWith(panel); return; }
          save(key, v, wrap);
        });
        var rm = wrap.querySelector('[data-engrave-remove]');
        if (rm) rm.addEventListener('click', function () { save(key, '', wrap); });
        input.focus();
      }
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-engrave-edit]');
        if (!t) return;
        e.preventDefault();
        e.stopPropagation();
        openEditor(t);
      });
    })();
  })();

})();
